export enum RUMAggregationType {
  MED = "MED",
  AVG = "AVG",
  P75 = "P75",
  P90 = "P90",
  P95 = "P95",
  P98 = "P98",
  P99 = "P99",
}

export const RUMAggregationTypeLabels: Record<RUMAggregationType, string> = {
  [RUMAggregationType.MED]: "Median",
  [RUMAggregationType.AVG]: "Average",
  [RUMAggregationType.P75]: "75th Percentile",
  [RUMAggregationType.P90]: "90th Percentile",
  [RUMAggregationType.P95]: "95th Percentile",
  [RUMAggregationType.P98]: "98th Percentile",
  [RUMAggregationType.P99]: "99th Percentile",
};
